import { RateQuoteAccessorial } from '../RateQuoteAccessorial';
import { RateQuoteChargeUpliftRuleUnit } from '../RateQuoteChargeUpliftRuleUnit';
import { RateUplift } from '../RateUplift';

import { BaseEditQuoteChargeTableItem } from './BaseEditQuoteChargeTableItem';

export class EditQuoteThreeplChargeTableItem extends BaseEditQuoteChargeTableItem {
  buyRate: number = 0;
  marginRate: number = 0;
  sellRate: number = 0;
  upliftUnit: RateQuoteChargeUpliftRuleUnit =
    RateQuoteChargeUpliftRuleUnit.FLAT;

  constructor(opts?: Partial<EditQuoteThreeplChargeTableItem>) {
    super(opts);

    if (opts?.buyRate != null) {
      this.buyRate = opts.buyRate;
    }
    if (opts?.marginRate != null) {
      this.marginRate = opts.marginRate;
    }
    if (opts?.sellRate != null) {
      this.sellRate = opts.sellRate;
    }
    if (typeof opts?.upliftUnit === 'string') {
      this.upliftUnit = RateQuoteChargeUpliftRuleUnit.parse(opts.upliftUnit);
    } else if (opts?.upliftUnit != null) {
      this.upliftUnit = opts.upliftUnit;
    }
  }

  get upliftAmount(): number {
    if (this.upliftUnit === RateQuoteChargeUpliftRuleUnit.PERCENT) {
      return this.buyRate * (this.marginRate / 100);
    }
    return this.marginRate;
  }

  rateAmount(rateType?: 'buy' | 'margin' | 'sell'): number {
    switch (rateType) {
      case 'buy':
        return this.buyRate;
      case 'margin': {
        if (this.upliftUnit === RateQuoteChargeUpliftRuleUnit.PERCENT) {
          return this.sellRate - this.buyRate;
        } else {
          return this.marginRate;
        }
      }
      case 'sell':
        return this.sellRate;
      default:
        throw new Error('Invalid rate type for 3PL', rateType);
    }
  }

  /**
   * Calculate sell rate based on current uplift unit
   */
  calculateSellRate(): number {
    return this.buyRate + this.upliftAmount;
  }

  /**
   * Calculate margin rate from sell rate based on current uplift unit
   */
  calculateMarginRate(): number {
    const upliftAmount = this.sellRate - this.buyRate;

    if (this.upliftUnit === RateQuoteChargeUpliftRuleUnit.PERCENT) {
      return this.buyRate === 0 ? 0 : (upliftAmount / this.buyRate) * 100;
    }

    return Math.round(upliftAmount * 100) / 100;
  }

  toNewRateQuoteAccessorial(): RateQuoteAccessorial {
    return new RateQuoteAccessorial({
      code: this.chargeCode,
      accessorialDescription: this.chargeCode?.name,
      charge: this.buyRate,
      upliftedAmount: this.sellRate,
      upliftAmount: this.upliftAmount,
      upliftRule: new RateUplift({
        upliftRate: this.marginRate,
        upliftRateUnit: this.upliftUnit,
      }),
      stopSequenceNumber: this.stopSequenceNumber,
    });
  }
}
